<ion-app [class]="environment.bundleName">
	<ion-router-outlet>
		<div class="app-initializer" [class.fade]="fadeLoader()">
			<img class="logo" height="160px" src="/assets/icons/iconbg.png" />
		</div>
	</ion-router-outlet>
<!--	@if(clientContext){-->
<!--		<app-core-root [context]="clientContext.coreContext"></app-core-root>-->
<!--	}-->
<!--	@else if(adminContext){-->
<!--		<ion-router-outlet></ion-router-outlet>-->
<!--	}-->
<!--	@else if(unauthenticatedContext){-->
<!--		<ion-router-outlet></ion-router-outlet>-->
<!--	}-->
</ion-app>
